export const DEFAULT_STATE = {
    data: null,
    isLoading: false,
};
